import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g transform="translate(0 3)">
      <polygon points="7 7 9 7 9 3 7 3"/>
      <polygon points="3 7 5 7 5 3 3 3"/>
      <polygon points="11.025 7 13.025 7 13.025 3 11.025 3"/>
      <polygon points="3.5 10.75 4.5 10.75 4.5 8.35 3.5 8.35"/>
      <polygon points="6.175 10.75 7.176 10.75 7.176 8.35 6.175 8.35"/>
      <polygon points="8.85 10.75 9.85 10.75 9.85 8.35 8.85 8.35"/>
      <polygon points="11.525 10.75 12.525 10.75 12.525 8.35 11.525 8.35"/>
      <path d="M0,0.0004 L0,7.04920602 L1,7.04920602 L1,10.7475239 L2,10.7475239 L2,7.04920602 L14,7.04920602 L14,10.7475239 L15,10.7475239 L15,7.04920602 L16,7.04920602 L16,0.0004 L0,0.0004 Z M1,6.0004 L15,6.0004 L15,1.0004 L1,1.0004 L1,6.0004 Z"/>
    </g>
  </svg>
);
